export default "__VITE_ASSET__BHE9uP49__"